import { createApp } from "vue";
import App from "@/views/App";
import router from "@/router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/styles/app.scss";
import { createPinia } from "pinia";

import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

import * as ElementPlusIconsVue from "@element-plus/icons-vue";

const main = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  main.component(key, component);
}

main.config.performance = process.env.NODE_ENV !== "production";
main.use(createPinia());
main.use(router);
main.use(ElementPlus);

main.use(PrimeVue, {
  theme: {
      preset: Aura
  }
});
main.mount("#app");

// import { createApp } from "vue";
// import Translate from "./views/translate";

// const app = createApp({
//   components: {
//     Translate,
//   },
// });

// app.mount("#app");
